








import { Vue, Component } from 'vue-property-decorator'
import * as _ from 'underscore'
import config from '../../config'
import showDiv, { closeAll } from '@ivy/fts/showDiv'
import { env } from '@ivy/fts/envInfo/envInfo'
import * as utils from '@ivy/fts/utils'
@Component({})
export default class TalentShow extends Vue {
  async mounted() {
    await env.init()
  }
  toMini() {
    env.toWXMiniProgram({
      username: 'gh_11eaa51d3211',
      path: 'pages/index/index',
      miniQr:
        'http://service.ivydad.com/tools/upload/8dc2fd8e-3c28-aef5-a412-2c8324f63d07.jpg',
    })
  }
}
